import { Link } from "react-router-dom";
import { GraduationCap, Mail, Phone, MapPin } from "lucide-react";

const footerLinks = {
  Subjects: [
    { label: "Mathematics", to: "/subjects/mathematics" },
    { label: "Physics", to: "/subjects/physics" },
    { label: "Chemistry", to: "/subjects/chemistry" },
    { label: "Biology", to: "/subjects/biology" },
    { label: "English", to: "/subjects/english" },
    { label: "Computer Science", to: "/subjects/computer-science" },
  ],
  Company: [
    { label: "About Us", to: "/about" },
    { label: "How It Works", to: "/how-it-works" },
    { label: "Our Teachers", to: "/teachers" },
    { label: "FAQ", to: "/faq" },
  ],
  Support: [
    { label: "Terms of Service", to: "/terms" },
    { label: "Privacy Policy", to: "/privacy" },
    { label: "Contact Us", to: "/contact" },
  ],
};

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#2C3333] text-white pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-12">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <GraduationCap className="w-8 h-8 text-[#ECB390]" />
              <span className="font-heading text-xl font-bold text-white">LearnSphere</span>
            </Link>
            <p className="text-sm text-white/60 leading-relaxed max-w-sm mb-6">
              Connecting students with world-class tutors for personalized one-on-one learning experiences that unlock potential.
            </p>
            <div className="space-y-2">
              <a href="mailto:tutorviaa@gmail.com" className="flex items-center gap-2 text-sm text-white/60 hover:text-[#ECB390] transition-colors">
                <Mail className="w-4 h-4 text-[#ECB390]" />
                <span>tutorviaa@gmail.com</span>
              </a>
              <a href="tel:+917009201851" className="flex items-center gap-2 text-sm text-white/60 hover:text-[#ECB390] transition-colors" data-testid="footer-phone-1">
                <Phone className="w-4 h-4 text-[#ECB390]" />
                <span>+91-7009201851</span>
              </a>
              <a href="tel:+919878035355" className="flex items-center gap-2 text-sm text-white/60 hover:text-[#ECB390] transition-colors" data-testid="footer-phone-2">
                <Phone className="w-4 h-4 text-[#ECB390]" />
                <span>+91-9878035355</span>
              </a>
              <div className="flex items-center gap-2 text-sm text-white/60">
                <MapPin className="w-4 h-4 text-[#ECB390]" />
                <span>Global, 100% Online</span>
              </div>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading font-semibold text-white mb-4 text-sm uppercase tracking-wider">{title}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className="text-sm text-white/50 hover:text-[#ECB390] transition-colors duration-200">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} LearnSphere. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/terms" className="text-xs text-white/40 hover:text-white/70 transition-colors">Terms</Link>
            <Link to="/privacy" className="text-xs text-white/40 hover:text-white/70 transition-colors">Privacy</Link>
            <Link to="/contact" className="text-xs text-white/40 hover:text-white/70 transition-colors">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
